const cancelToken = {
  state: {
    cancelTokenArr: []  // 取消请求的token数组
  },
  mutations: {
    PUSH_TOKEN(state, payload) {
      state.cancelTokenArr.push(payload.cancelToken)
    },
    CLEAR_TOKEN(state, cancelTokenArr){
      state.cancelTokenArr.forEach(item => {
        // 执行取消函数
        item && item()
      })
      // 执行完后清空
      state.cancelTokenArr = []
    }
  },
  actions: {
    pushToken({commit}, payload){
      commit('PUSH_TOKEN', payload)
    },
    clearToken({commit}, cancelTokenArr){
      commit('CLEAR_TOKEN')
    }
  }
}

export default cancelToken